import React from 'react'
import FooterContainer from '../../@c_containers/footer/footer.container'

const FooterTemplate = function () {
  return <FooterContainer>This is footer</FooterContainer>
}

export default FooterTemplate
